module.exports = __webpack_public_path__ + "img/image14.b55dd142.svg";